import React, { Component, Fragment } from 'react'
import elements from '../elements'
import customElements from '../custom/elements'

export default class RecursiveElement extends Component {
  render() {
    // catch element type errors
    if (
      !Array.isArray(this.props.element)
      && !(this.props.element.type !== undefined && this.props.element.type === 'text')
      && !(this.props.element.type !== undefined && this.props.element.type === 'tag')
    ) {
      return (
        // <span className="alert alert-danger">
        //   Unkwnown element type {this.props.element.type}
        // </span>
        <span></span>
      )
    }
    // valid elements
    // text element
    if (this.props.element.type !== undefined && this.props.element.type === 'text') {
      return this.props.element.data.replace(/\r\n/g, '\n').split('\n').map(( item, key, array) => ( // split by new lines because of wpautop disabled
        <Fragment key={key}>
          {item}
          { key + 1 < array.length ? <br /> : null }
        </Fragment>
      ))
    }
    // tag element
    if (this.props.element.type !== undefined && this.props.element.type === 'tag') {
      const children = this.props.element.children !== undefined ? <RecursiveElement element={this.props.element.children} post={this.props.post} /> : null

      // allows element override (custom first)
      const result = customElements.concat(elements).find(element => element.match(this.props))
      if (result)
        return result.render({ ...this.props, children })

      // FIXME: pare styles values to protect against XSS!!!!!!!
      const styleParser = style => style === undefined ? undefined : JSON.parse("{" + style.replace(/([-a-z]+):([^;]+)(;)?/gi, function(m, name, value, semicolon) {
        const styleNameRegex = /([a-z]+[^-])+(-)?/gi
        const newName = name.replace(styleNameRegex, function(m, styleName, styleDash) {
          return styleName.charAt(0).toUpperCase() + styleName.slice(1)
        })
        return "\"" + newName.charAt(0).toLowerCase() + newName.slice(1) + "\":\"" + value + "\""
      }) + "}")

      // this version can handle all attribs, but will be slower then prvious
      const attribs = { }
      Object.keys(this.props.element.attribs).forEach(key => {
        switch (key) {
          case 'class': attribs.className = this.props.element.attribs.class; break
          case 'style': attribs.style = styleParser(this.props.element.attribs.style); break
          default: attribs[key] = this.props.element.attribs[key]
        }
      })
      return (
        <this.props.element.name {...attribs}>
          {children}
        </this.props.element.name>
      )

      // this is previous version which can handle only predefined attribs
      // return (
      //   <this.props.element.name className={this.props.element.attribs.class} style={styleParser(this.props.element.attribs.style)} data-vc-tag-name={this.props.element.attribs['data-vc-tag']} >
      //     {children}
      //   </this.props.element.name>
      // )

    }
    // array of elements
    if (Array.isArray(this.props.element)) {
      return this.props.element.map((item, key) => (<RecursiveElement key={key} element={item} post={this.props.post} />))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/RecursiveElement.js